export default {
  siteTitle: 'Irena Popova',
  siteUrl: 'http://irenaapp.de/',
  siteLogo: '/logo.png',
  description:
    'Web developer and Linguist. This is my digital notebook.',
  userTwitter: 'irenapopova',
}
